import { COLOR_NAMES } from "../constants";
import { useTheme } from "styled-components";

export const useColors = () => {
  const theme = useTheme();
  return COLOR_NAMES.map((color) => theme[color]);
};
